import { RateFilters } from '@reliance/types/filters/RateFilters';
import { RatePlan } from '@reliance/types/models/RatePlan';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { IPaginatedResponse } from '../common/reliance-api-service';

export const useRatePlans = (filters?: RateFilters) => {
  return useAsync<IPaginatedResponse<RatePlan>>(
    () => api.get<IPaginatedResponse<RatePlan>>('/rate', { params: filters }).then(r => r.data),
    [filters]
  );
};